import { render, staticRenderFns } from "./div-box.vue?vue&type=template&id=28c5de50&scoped=true"
import script from "./div-box.vue?vue&type=script&lang=js"
export * from "./div-box.vue?vue&type=script&lang=js"
import style0 from "./div-box.vue?vue&type=style&index=0&id=28c5de50&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c5de50",
  null
  
)

export default component.exports